import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, ButtonGroup, Typography, Box, Fab, Badge, Divider, Tooltip, IconButton, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { formatDateTime, formatMinutosHoras, isColorDark, obtenerFechaHoraSQL, textoMayusculas } from '../../../utils/utils';
import { actualizarTarea, eliminarTarea, postCitaCalendario, updateTarea } from '../../../services/apis';
import InfoIcon from '@mui/icons-material/Info';
import { TareaDialog } from './TareaDialog';
import { FormEditarTarea } from './FormEditarTareay';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CreateIcon from '@mui/icons-material/Create';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { advertenciaEliminar } from '../../../utils/componentes-utiles/advertencias';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import CircleIcon from '@mui/icons-material/Circle';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

export const TareaCard = ({ tarea, opciones, estados, cargarTareas, opclientes, opTrabajadores, opProyectos, nombreProyectoActual, tiposDeTarea, opcionesTipoTareas, setPausarRecargaTareas }) => {

    const [tareaInfo, setTareaInfo] = useState(tarea);
    const [tareaEditar, setTareaEditar] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [backgroundCard, setBackgroundCArd] = useState(estados.find(estado => estado.id === tareaInfo.id_estado).color);
    const [tipoTarea, setTipoTarea] = useState(tiposDeTarea.find(tipoTarea => tipoTarea.id === tareaInfo.id_tipo_tarea));

    const [textColor, setTextColor] = useState(isColorDark(tareaInfo.estado_color) ? '#FFFFFF' : '#000000');
    const [errorAlert, setErrorAlert] = useState(false);
    const [horasTotales, setHorasTotales] = useState(0);
    const [validar, setValidar] = useState(false);
    const [openAgendar, setOpenAgendar] = useState(false);
    const [fechaAgendar, setFechaAgendar] = useState(new Date().toISOString().split('T')[0]);
    const [horaAgendar, setHoraAgendar] = useState('');
    const [guardandoAgenda, setGuardandoAgenda] = useState(false);
    const [errorAgenda, setErrorAgenda] = useState('');
    const [colorTipoTarea, setColorTipoTarea] = useState(tipoTarea ? tipoTarea.color : '#00000f');
    const tieneExtras = Number(tareaInfo.total_extras_tareas || tareaInfo.total_extras || 0) > 0;
    const importeExtras = Number(tareaInfo.importe_extras_tareas || tareaInfo.importe_extras || 0);
    const tieneDesplazamientos = Number(tareaInfo.total_desplazamientos_tareas || 0) > 0;
    const totalDesplazamientos = Number(tareaInfo.cantidad_desplazamientos_tareas || 0);
    const tareaAgendadaCalendario = Number(tareaInfo.total_citas_calendario_tarea || 0) > 0;
    const nombreProyectoActualNormalizado = Array.isArray(nombreProyectoActual)
        ? (nombreProyectoActual[0]?.label || nombreProyectoActual[0]?.nombre || '')
        : nombreProyectoActual;
    const nombreProyectoTarea = tareaInfo.nombre_proyecto
        || opProyectos?.find((proyecto) => String(proyecto.value) === String(tareaInfo.id_proyecto))?.label
        || nombreProyectoActualNormalizado
        || '';
    const tareaInfoParaEditar = {
        ...tareaInfo,
        nombre_proyecto: nombreProyectoTarea
    };
    const opProyectosParaEditar = React.useMemo(() => {
        const opcionesValidas = (opProyectos || []).filter(
            (proyecto) => proyecto?.label && proyecto?.value !== undefined && proyecto?.value !== null
        );

        if (
            tareaInfo.id_proyecto &&
            nombreProyectoTarea &&
            !opcionesValidas.some((proyecto) => String(proyecto.value) === String(tareaInfo.id_proyecto))
        ) {
            return [
                { label: nombreProyectoTarea, value: tareaInfo.id_proyecto },
                ...opcionesValidas
            ];
        }

        return opcionesValidas;
    }, [opProyectos, tareaInfo.id_proyecto, nombreProyectoTarea]);


    //cambiar dinamicamente el color del fondo de la tarjeta
    useEffect(() => {
        setTextColor(isColorDark(estados.find(estado => estado.id == tareaInfo.id_estado).color) ? '#FFFFFF' : '#000000');
        setBackgroundCArd(estados.find(estado => estado.id == tareaInfo.id_estado).color);
    }, [tareaInfo.id_estado]);

    useEffect(() => {
        setTareaInfo(tarea);
    }, [tarea])

    const iconMapping = {
        DoneAllIcon: <DoneAllIcon sx={{ ml: 0.5 }} />,
        PlayArrowIcon: <PlayArrowIcon sx={{ ml: 0.5 }} />,
        PauseIcon: <PauseIcon sx={{ ml: 0.5 }} />,
        EditIcon: <EditIcon sx={{ ml: 0.5 }} />,
        CreateIcon: <CreateIcon sx={{ ml: 0.5 }} />,
        DeleteForeverIcon: <DeleteForeverIcon sx={{ ml: 0.5 }} />,
        FactCheckIcon: <FactCheckIcon sx={{ ml: 0.5 }} />
    };
    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                handleOnChange({ id_estado: 1 })
                // Lógica para la opción 1
                break;
            case 2:
                handleOnChange({ id_estado: 2 })
                // Lógica para la opción 2
                break;
            case 3:
                if (opcionId === 3 && tareaInfo.horas_totales < 15) {
                    setErrorAlert(true);
                }
                else {
                    handleOnChange({ id_estado: 3 })

                }

                // Lógica para la opción 3
                break;
            case 4:
                setValidar(true)
                // handleOnChange({ id_estado: 4 })
                // Lógica para la opción 4
                break;
            case 50:
                setTareaEditar(true);
                break;
            case 51:
                eliminarTareaF(tareaInfo.id);
                break;
            case 90:
                // Lógica para la opción 4
                break;
            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }

    const activarBoton = (opcion, infoTarea) => {

        switch (opcion.id_estado) {
            case 50:
                if (infoTarea.id_estado === 4) {
                    return true;
                } else {
                    return false;
                }
            case 1:
                if (infoTarea.id_estado === 0 || infoTarea.id_estado === 2 || !infoTarea.userencurso) {
                    return false;
                } else {
                    return true;
                }
            case 2:
                if (infoTarea.id_estado === 1 && infoTarea.userencurso) {

                    return false;
                } else {
                    return true;
                }

            case 3:
                if (infoTarea.id_estado === 0 || infoTarea.id_estado === 1 || infoTarea.id_estado === 2) {
                    return false;
                } else {
                    return true;
                }
            case 4:
                if (infoTarea.id_estado === 3 || infoTarea.id_estado === 4) {
                    return false;
                } else {
                    return true;
                }

            case 51:
                if (infoTarea.id_estado === 4) {
                    return true;
                } else {
                    return false;
                }
            default:
                return true;
        }
    }



    const handleOnChange = (data) => {        
        // Crear una copia del objeto tarea
        let temp = { ...tareaInfo };
        // Obtener la clave y el valor del objeto data
        const [key, value] = Object.entries(data)[0];

        // Verificar si la clave existe en el objeto tarea
        if (temp.hasOwnProperty(key)) {
            // Cambiar el valor del elemento que coincide
            temp[key] = value;
        }
        // Actualizar el estado de tarea con el nuevo objeto modificado
        // Suponiendo que estás usando useState para manejar el estado de tarea
        // setTareaInfo(temp); si se deja activo da la falsa ilusion de que laggea
        console.log("TEMPPPPPPPPPPPPPPPPPPPPPP",temp);
        
        actualizarTareaEstado(temp);
        // Para fines de depuración
    };

    const actualizarTareaEstado = (data) => {
        let temp = { ...data };
        temp.fechaActual = obtenerFechaHoraSQL();
        actualizarTarea(temp).then(() => {
            cargarTareas(); // Se ejecuta después de que actualizarTarea se completa
        })
    }



    const eliminarTareaF = async (id) => {
        const titulo = "Eliminar Tarea " + tareaInfo.id;
        const texto = "Vas a eliminar permanentemente esta tarea";

        // Asegúrate de esperar el resultado de advertenciaEliminar
        const confirmado = await advertenciaEliminar(titulo, texto);
        if (confirmado) {
            try {
                const response = await eliminarTarea(id)
                if (response.success == true) {
                    cargarTareas();
                }
            }
            catch (error) {
                console.error("Error al eliminar la tarea:", error);

            }
        }

    };

    const abrirDialogAgendar = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (tareaAgendadaCalendario) return;

        setFechaAgendar(new Date().toISOString().split('T')[0]);
        setHoraAgendar('');
        setErrorAgenda('');
        setOpenAgendar(true);
    };

    const agendarTarea = async () => {
        if (!fechaAgendar) {
            setErrorAgenda('Selecciona una fecha para agendar la tarea.');
            return;
        }

        setGuardandoAgenda(true);
        setErrorAgenda('');

        const trabajadoresAsignados = Array.isArray(tareaInfo.trabajadores)
            ? tareaInfo.trabajadores
                .map((trabajador) => trabajador?.label)
                .filter(Boolean)
                .join(', ')
            : '';

        const response = await postCitaCalendario({
            asunto: tareaInfo.asunto,
            fecha: horaAgendar ? `${fechaAgendar} ${horaAgendar}:00` : fechaAgendar,
            descripcion: [
                tareaInfo.cliente ? `CLIENTE_TAREA:${tareaInfo.cliente}` : '',
                trabajadoresAsignados ? `TRABAJADORES_TAREA:${trabajadoresAsignados}` : '',
                `ID_TAREA_CALENDARIO:${tareaInfo.id};`
            ].filter(Boolean).join('\n'),
            id_estado: tareaInfo.id_estado || null
        });

        setGuardandoAgenda(false);

        if (!response?.success) {
            setErrorAgenda(response?.message || 'No se pudo agendar la tarea.');
            return;
        }

        setOpenAgendar(false);
        setTareaInfo(prev => ({
            ...prev,
            total_citas_calendario_tarea: Math.max(1, Number(prev.total_citas_calendario_tarea || 0) + 1)
        }));
    };

    useEffect(() => {
        const nuevoTipoTarea = tiposDeTarea.find(tipo => tipo.id === tareaInfo.id_tipo_tarea);
        setTipoTarea(nuevoTipoTarea);
        setColorTipoTarea(nuevoTipoTarea ? nuevoTipoTarea.color : '#00000f');

    }, [tareaInfo.id_tipo_tarea, tiposDeTarea]);


    return (
        <Grid
            container
            direction="column"
            justifyContent="start"
            alignItems="center"
            xs={12}
            fontWeight={500}
            padding={2}
            style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                minHeight: '40vh',
                maxHeight: '100vh',
            }}
            className="tarea-card fade-in2"
        >
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={12}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="start"
                    xs={11.5}
                    sx={{
                        minHeight: '7vh',
                        maxHeight: '20vh',
                        // backgroundColor: 'red'
                    }}
                >
                    <Typography variant="body1">
                        Tarea: {tareaInfo.id}
                    </Typography>
                    {tipoTarea && (
                        <Grid item xs={1.5} onClick={() => setOpen(true)} className='pointer'>
                            <Tooltip title={tipoTarea.nombre} placement="top">
                                < CircleIcon sx={{
                                    color: colorTipoTarea,
                                }} />
                            </Tooltip>
                        </Grid>
                    )}

                    <Grid
                        item
                        xs={1.5}
                        container
                        direction="column"
                        alignItems="center"
                    >
                        <Tooltip title={tareaAgendadaCalendario ? "Tarea ya agendada en calendario" : "Agendar en calendario"} placement="top">
                            <span>
                                <IconButton
                                    size="small"
                                    onClick={abrirDialogAgendar}
                                    disabled={tareaAgendadaCalendario}
                                    sx={{
                                        color: tareaAgendadaCalendario ? '#2e7d32' : textColor,
                                        p: 0.2,
                                        opacity: tareaAgendadaCalendario ? 1 : undefined,
                                        '&.Mui-disabled': {
                                            color: '#2e7d32',
                                        },
                                    }}
                                >
                                    <EventAvailableIcon sx={{ fontSize: 28 }} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>

                    <Grid
                        item
                        xs={1.5}
                        container
                        direction="column"
                        alignItems="center"
                        onClick={() => setOpen(true)}
                        className='pointer'
                    >
                        <Badge badgeContent={tareaInfo.comentarios.total_comentarios} color="primary">
                            <InfoIcon sx={{ fontSize: 30, marginBottom: (tieneExtras || tieneDesplazamientos) ? 0.2 : 2 }} />
                        </Badge>

                        {(tieneExtras || tieneDesplazamientos) && (
                            <Box display="flex" alignItems="center" justifyContent="center" gap={0.4}>
                        {tieneExtras && (
                            <Tooltip title={`Material extra: ${importeExtras}€`} placement="top">
                                <AttachMoneyIcon
                                    sx={{
                                        fontSize: 24,
                                        mt: 0.2,
                                        opacity: 0.95,
                                    }}
                                />
                            </Tooltip>
                        )}

                        {tieneDesplazamientos && (
                            <Tooltip title={`Desplazamientos: ${totalDesplazamientos}`} placement="top">
                                <DirectionsCarIcon
                                    sx={{
                                        fontSize: 24,
                                        mt: 0.2,
                                        opacity: 0.95,
                                    }}
                                />
                            </Tooltip>
                        )}
                            </Box>
                        )}
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="start"
                        xs={12}

                    >
                        {tareaInfo.nombre_proyecto && (
                            <Typography
                                variant="body1"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: 'vertical',
                                    fontWeight: 700,
                                    textDecoration: 'underline',
                                    textDecorationColor: 'var(--principal)',
                                }}
                            >
                                {tareaInfo.nombre_proyecto}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} textAlign={'left'} >
                        <Typography variant="body1"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 1, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                                fontWeight: 700,
                            }}
                        >

                            {textoMayusculas(tareaInfo.cliente)}
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        gap={1}
                        sx={{ mt: 0 }}
                    >
                        <Grid item xs={6} style={{
                            textAlign: 'left',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                        }} >
                            <Typography variant="caption" >
                                {tareaInfo.correo}
                            </Typography>
                        </Grid>

                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                            <Typography variant="caption">
                                {formatDateTime(tareaInfo.fecha)}
                            </Typography>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="start"
                xs={11.5}
                sx={{
                    // backgroundColor: 'red',
                    minHeight: '10vh',
                    maxHeight: '20vh',
                }}
            >
                <Typography variant="h6" gutterBottom textAlign={'left'} className='lineas-max-2'>
                    {tareaInfo.asunto}
                </Typography>
                <Grid container xs={12} justifyContent="start" alignItems="start">
                    <Typography variant="body2" gutterBottom textAlign={'left'} className='lineas-max-2'>
                        {tareaInfo.segunda_referencia ? tareaInfo.segunda_referencia : ''}
                    </Typography>
                </Grid>
                <Grid container xs={12} justifyContent="start" alignItems="start">
                    <Typography variant="body2" gutterBottom textAlign={'left'} className='lineas-max-2'>
                        {tareaInfo.descripcion}
                    </Typography>
                </Grid>


            </Grid>

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="start"
                xs={11.5}
                style={{
                    // backgroundColor: 'red',
                    minHeight: '6vh',
                    maxHeight: '15vh',
                    marginTop: 6
                }}
            >
                {tareaInfo.trabajadores.length > 0 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                    >
                        {tareaInfo.trabajadores.length > 0 && (
                            <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                                <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" >
                                    <Typography variant="subtitle2" gutterBottom>
                                        Asignado a:&nbsp;
                                        {(tareaInfo.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                            <span>{trabajador.label}&nbsp;</span>
                                        ))}
                                    </Typography>
                                </Grid>


                                <>
                                    {tareaInfo.trabajadores.length > 3 && (
                                        <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                            y mas...
                                        </Typography>
                                    )}
                                </>
                            </Grid>
                        )}
                    </Grid>
                )}



                {tareaInfo.usuarios_con_tiempo.length > 0 && (
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12}
                    // style={{
                    // minHeight: '15vh',
                    // maxHeight: '35vh',
                    // }}
                    >
                        {tareaInfo.usuarios_con_tiempo.length > 0 && (
                            <Grid container xs={12} justifyContent="start" alignItems="start">
                                <Typography variant="subtitle2" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                    En curso por:&nbsp;
                                    {(tareaInfo.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                        <span>{trabajador.label}&nbsp;</span>
                                    ))}
                                </Typography>

                                <>
                                    {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                        <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                            y mas...
                                        </Typography>
                                    )}
                                </>
                            </Grid>
                        )}
                    </Grid>
                )}
                <Typography variant='caption'>
                    Horas totales: {
                        tareaInfo.horas_totales
                            ? `${Math.floor(tareaInfo.horas_totales / 60)}h ${tareaInfo.horas_totales % 60}m`
                            : '0h 0m'
                    }
                </Typography>

            </Grid>


            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                xs={11.5}
                gap={1}
                style={{ marginTop: '0em' }}
            >
                {/* {console.log(opciones)
                } */}
                {opciones.map((opcion, index) => (
                    <Grid container xs={2} key={index} alignItems='center' justifyContent='center' >
                        <Fab
                            fullWidth
                            size="small"
                            variant='contained'
                            className='button-default'
                            color="primary"
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            title={opcion.nombre}
                            disabled={activarBoton(opcion, tareaInfo)} // Aquí puedes implementar la lógica para habilitar o deshabilitar el botón según tu lógica de negocio
                        >

                            {iconMapping[opcion.icono] && (
                                <>
                                    {iconMapping[opcion.icono]}&nbsp;
                                </>
                            )}
                        </Fab>
                    </Grid>
                ))}

                <Typography variant='caption' sx={{ mt: 1 }}>
                    <strong>Creado por: </strong>{tareaInfo.creador}
                </Typography>

            </Grid>





            {/* //desplegable */}
            <Dialog
                open={validar}
                onClose={() => setValidar(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {tareaInfo.id_estado === 4
                        ? "¿Estas seguro de desvalidar esta tarea?"
                        : "¿Estas seguro de validar esta tarea?"
                    }
                </DialogTitle>

                <DialogActions>
                    <Button onClick={() => setValidar(false)} color="primary" autoFocus variant='outlined'>
                        Cancelar
                    </Button>
                    <Button onClick={() => {
                        handleOnChange(tareaInfo.id_estado === 4 ? { id_estado: 3 } : { id_estado: 4 });
                        setValidar(false);
                    }} color="primary" variant='contained'>
                        {tareaInfo.id_estado === 4
                            ? "Desvalidar"
                            : "Validar"
                        }
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openAgendar}
                onClose={() => setOpenAgendar(false)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    Agendar tarea
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ pt: 1 }}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                {tareaInfo.asunto}
                            </Typography>
                            {tareaInfo.cliente && (
                                <Typography variant="body2" color="text.secondary">
                                    Cliente: {textoMayusculas(tareaInfo.cliente)}
                                </Typography>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Fecha"
                                value={fechaAgendar}
                                onChange={(event) => {
                                    setFechaAgendar(event.target.value);
                                    setErrorAgenda('');
                                }}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="time"
                                label="Hora"
                                value={horaAgendar}
                                onChange={(event) => {
                                    setHoraAgendar(event.target.value);
                                    setErrorAgenda('');
                                }}
                                InputLabelProps={{ shrink: true }}
                                helperText="Opcional"
                            />
                        </Grid>

                        {errorAgenda && (
                            <Grid item xs={12}>
                                <Typography variant="body2" color="error">
                                    {errorAgenda}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenAgendar(false)} color="primary" variant="outlined">
                        Cancelar
                    </Button>
                    <Button onClick={agendarTarea} color="primary" variant="contained" disabled={guardandoAgenda}>
                        {guardandoAgenda ? 'Guardando...' : 'Agendar'}
                    </Button>
                </DialogActions>
            </Dialog>
            {
                tareaEditar == true && (
                    <FormEditarTarea open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfoParaEditar} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tareaInfo.trabajadores} opcionesTipoTareas={opcionesTipoTareas} opProyectosPreCargados={opProyectosParaEditar} />
                )
            }
            {/* {
                tareaEditar == true && (
                    <FormEditarTarea open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tarea.trabajadores} />
                )
            } */}
            <Grid container xs={12} justifyContent={'space-between'}>
                <TareaDialog open={open} setOpen={setOpen} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo} opciones={opciones} handleEvent={handleEvent} backgroundCard={backgroundCard} textColor={textColor} setHorasTotales={setHorasTotales} setPausarRecargaTareas={setPausarRecargaTareas} />
            </Grid >
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Minimo 15 minutos de trabajo"} />
                )

            }
        </Grid >


    )
}
